import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import 'datatables.net-responsive-bs5';
import $ from 'jquery';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { EmpresaModalComponent } from '../empresa-modal/empresa-modal.component';
import { languageSettings } from '../lenguajeDatatable';
import { PersonaModalComponent } from '../persona-modal/persona-modal.component';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { ToastService } from '../services/toast.service';
import { VendedorModalComponent } from '../vendedor-modal/vendedor-modal.component';

@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrl: './persona.component.css',
})
export class PersonaComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(PersonaModalComponent) personaModal!: PersonaModalComponent;
  @ViewChild(VendedorModalComponent) vendedorModal!: VendedorModalComponent;
  @ViewChild(EmpresaModalComponent) empresaModal!: EmpresaModalComponent;

  personas: any[] = [];
  dataTable: any;
  filtro: any = {};
  personaSeleccionada: any = {
    sexo: {},
    parentesco: {},
    estadoCivil: {},
    nacionalidad: {},
    obraSocial: {},
    plan: {},
    tipoBeneficiario: {},
    revista: {},
    fechaNacimiento: '',
    fechaVenta: '',
    localidad: { provincia: { id: null } },
    vendedor: {},
    cuitEmpresa: '',
    aporteInicial: 0.0,
  };
  resultados: any = {};
  tienePlanFijo: boolean = false;
  mostrarTabla: boolean = false;
  editando: boolean = false;
  tieneAdherentes: boolean = false;
  mostrarBotonEditar: boolean = false;
  errores: { [key: string]: string } = {};
  private readonly SOLO_LETRAS = /^[a-zA-ZÀ-ÿ\s']+$/;
  private readonly SOLO_NUMEROS = /^[0-9]+$/;
  private readonly CUIL_VALIDO = /^[0-9]{11}$/;
  private readonly DNI_VALIDO = /^[0-9]{8}$/;
  private readonly TELEFONO_VALIDO = /^[0-9]{8,}$/;
  vendedores: any[] = [];
  maxDate!: NgbDateStruct;
  minDate!: NgbDateStruct;

  obrasSociales: any[] = [];
  planes: any[] = [];
  tiposBeneficiarios: any[] = [];
  sexos: any[] = [];
  estadosCiviles: any[] = [];
  nacionalidades: any[] = [];
  parentescos: any[] = [];
  revistas: any[] = [];
  provincias: any[] = [];
  localidades: any[] = [];

  empresas: any[] = [];
  empresaFiltro: string = '';
  empresaFiltrada: any[] = [];
  empresaSeleccionada: any = null;

  tipoModal: 'persona' | 'venta' = 'persona';
  termBusqueda: string = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  empresaModalSuscrito: boolean = false;

  constructor(
    private apiSrv: ApiService,
    private loadingSrv: LoadingService,
    private toastSrv: ToastService,
    private calendar: NgbCalendar
  ) {}

  ngOnInit(): void {
    this.apiSrv.obtenerObrasSociales().subscribe((data: any[]) => {
      this.obrasSociales = data;
    });

    this.apiSrv.obtenerPlanes().subscribe((data: any[]) => {
      this.planes = data;
    });

    this.apiSrv.obtenerTiposBeneficiarios().subscribe((data: any[]) => {
      this.tiposBeneficiarios = data;
    });

    this.apiSrv.obtenerSexos().subscribe((data: any[]) => {
      this.sexos = data;
    });

    this.apiSrv.obtenerEstadosCiviles().subscribe((data: any[]) => {
      this.estadosCiviles = data;
    });

    this.apiSrv.obtenerNacionalidades().subscribe((data: any[]) => {
      this.nacionalidades = data;
    });

    this.apiSrv.obtenerParentesco().subscribe((data: any[]) => {
      this.parentescos = data;
    });

    this.apiSrv.obtenerRevistas().subscribe((data: any[]) => {
      this.revistas = data;
    });

    this.apiSrv.obtenerProvincias().subscribe((data: any[]) => {
      this.provincias = data;
    });

    this.apiSrv.obtenerVendedoresActivos().subscribe((data: any[]) => {
      this.vendedores = data;
    });

    this.apiSrv.obtenerEmpresas().subscribe((data: any[]) => {
      this.empresas = (data || []).sort((a, b) =>
        a.razonSocial.localeCompare(b.razonSocial)
      );
      this.empresaFiltrada = this.empresas;
    });

    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((term) => {
        if (term && term.length >= 3) {
          this.buscarPersonas();
        }
      });

    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  ngAfterViewInit(): void {
    this.inicializarDataTable();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }

  buscarPersonas(): void {
    if (!this.termBusqueda || this.termBusqueda.length < 3) {
      this.toastSrv.mostrarNotificacion(
        'Ingresa al menos 3 caracteres para buscar.',
        'warning'
      );
      return;
    }

    this.loadingSrv.setLoading(true);
    this.apiSrv.buscarPersonas(this.termBusqueda).subscribe({
      next: (personas) => {
        this.resultados['persona'] = personas;
        this.loadingSrv.setLoading(false);

        if (personas.length === 0) {
          this.toastSrv.mostrarNotificacion(
            'No se encontraron resultados para la búsqueda.',
            'info'
          );
        }
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          'Error al buscar personas. Intente nuevamente.',
          'error'
        );
      },
    });
  }

  onSearchInput(): void {
    if (this.termBusqueda && this.termBusqueda.length >= 3) {
      this.searchSubject.next(this.termBusqueda);
    } else if (this.termBusqueda.length === 0) {
      this.resultados['persona'] = [];
    }
  }

  onSelectItem(event: any): void {
    this.personaSeleccionada = event;

    const provinciaId = this.personaSeleccionada?.localidad?.provincia.id;
    this.apiSrv.obtenerLocalidadesSegunIdProvincia(provinciaId).subscribe({
      next: (localidades) => {
        this.localidades = localidades;
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al cargar localidades.',
          'error'
        );
      },
    });

    if (
      this.personaSeleccionada.empresaPrincipal &&
      this.personaSeleccionada.empresaPrincipal.cuit
    ) {
      const cuitEmpresa =
        this.personaSeleccionada.empresaPrincipal.cuit.toString();

      this.empresaSeleccionada = this.empresas.find(
        (e) => e.cuit.toString() === cuitEmpresa
      );

      if (
        !this.empresaSeleccionada &&
        this.personaSeleccionada.empresaPrincipal
      ) {
        this.empresaSeleccionada = {
          cuit: this.personaSeleccionada.empresaPrincipal.cuit,
          razonSocial:
            this.personaSeleccionada.empresaPrincipal.razonSocial ||
            'Empresa no encontrada',
        };
      }

      this.personaSeleccionada.cuitEmpresa = cuitEmpresa;
    } else {
      this.empresaSeleccionada = null;
      this.personaSeleccionada.cuitEmpresa = null;
    }

    this.resultados['persona'] = [];
    this.mostrarBotonEditar = true;

    if (this.personaSeleccionada.fechaNacimiento) {
      const [day, month, year] =
        this.personaSeleccionada.fechaNacimiento.split('/');
      this.personaSeleccionada.fechaNacimiento = `${day}/${month}/${year}`;
    }

    if (this.personaSeleccionada.fechaVenta) {
      const [day, month, year] = this.personaSeleccionada.fechaVenta.split('/');
      this.personaSeleccionada.fechaVenta = `${day}/${month}/${year}`;
    }

    if (this.personaSeleccionada.domicilio) {
      const { calle, nro, piso, departamento } = this.parseDomicilio(
        this.personaSeleccionada.domicilio
      );
      this.personaSeleccionada.nombreDomicilio = calle;
      this.personaSeleccionada.numeroDomicilio = nro;
      this.personaSeleccionada.piso = piso;
      this.personaSeleccionada.departamento = departamento;
    }

    if (
      this.personaSeleccionada?.parentesco.descripcion
        ?.toLowerCase()
        .includes('titular')
    ) {
      this.mostrarTabla = true;
      this.rellenarDataTable();
      this.obtenerPlanFijo(this.personaSeleccionada?.cuil);
    } else {
      this.mostrarTabla = false;
    }
    this.tienePlanFijo = false;
    this.activarPestañaDatosPersonales();
  }

  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const inputFields = document.querySelectorAll('.form-control');
    const inputFieldsArray = Array.from(inputFields);

    if (!inputFieldsArray.some((input) => input.contains(target))) {
      this.resultados = {};
    }
  }

  private rellenarDataTable(): void {
    if (!this.personaSeleccionada?.cuil) {
      return;
    }
    this.loadingSrv.setLoading(true);
    this.apiSrv
      .obtenerAdherentesPorTitular(this.personaSeleccionada.cuil)
      .subscribe({
        next: (adherentes: any[]) => {
          this.loadingSrv.setLoading(false);

          this.dataTable.clear();
          if (adherentes && adherentes.length > 0) {
            this.tieneAdherentes = true;

            adherentes.forEach((persona) => {
              this.dataTable.row.add([
                persona.apellido + ' ' + persona.nombre,
                persona.documento,
                persona.cuil,
                persona.parentesco.descripcion,
                persona.fechaNacimiento,
                persona.sexo.descripcion,
                persona.activo ? 'Activo' : 'Inactivo',
                `<button class="btn btnVerAdherente btn-sm buttonCustom1" data-cuil="${persona.cuil}">Ver adherente</button>`,
              ]);
            });
          } else {
            this.tieneAdherentes = false;
          }
          this.dataTable.draw();

          $('#tablaPersonas tbody').on(
            'click',
            'button.btnVerAdherente',
            (event) => {
              const cuil = $(event.currentTarget).data('cuil');
              this.verAdherente(cuil);
            }
          );
        },
        error: (error) => {
          this.loadingSrv.setLoading(false);
          this.toastSrv.mostrarNotificacion(
            'Error al obtener los adherentes',
            'error'
          );
        },
      });
  }

  private inicializarDataTable(): void {
    this.dataTable = $('#tablaPersonas').DataTable({
      language: languageSettings,
      pageLength: 10,
      responsive: true,
      dom: 'tri',
    });
  }

  obtenerPlanFijo(cuil: string): void {
    this.apiSrv.obtenerPlanFijoPorCuil(cuil).subscribe(
      (data: any) => {
        const idPlan = parseInt(data.id, 10);
        this.tienePlanFijo = idPlan !== 0;
      },
      (error) => {
        this.tienePlanFijo = false;
      }
    );
  }

  activarPestañaDatosPersonales(): void {
    const tabs = document.querySelectorAll('.nav-link');
    tabs.forEach((tab) => tab.classList.remove('active'));
    const tabDatosPersonales = document.getElementById('datos-personales-tab');
    if (tabDatosPersonales) {
      tabDatosPersonales.classList.add('active');
    }
    const tabContents = document.querySelectorAll('.tab-pane');
    tabContents.forEach((content) =>
      content.classList.remove('show', 'active')
    );
    const datosPersonalesContent = document.getElementById('datos-personales');
    if (datosPersonalesContent) {
      datosPersonalesContent.classList.add('show', 'active');
    }
  }

  recargarPersonas(): void {
    this.resultados['persona'] = [];
  }

  editarPersona(): void {
    this.editando = true;
  }

  guardarCambios(): void {
    this.validarPersonaPrimerCampo().then((valido) => {
      if (!valido) {
        this.toastSrv.mostrarNotificacion('Errores en el formulario', 'error');
        return;
      }

      const personaDTO = {
        cuil: this.personaSeleccionada.cuil,
        documento: this.personaSeleccionada.documento,
        nombre: this.personaSeleccionada.nombre,
        apellido: this.personaSeleccionada.apellido,
        telefono: this.personaSeleccionada.telefono,
        fechaNacimiento: this.personaSeleccionada.fechaNacimiento,
        fechaEstado: this.personaSeleccionada.fechaEstado,
        fechaVenta: this.personaSeleccionada.fechaVenta,
        cuilTitular: this.personaSeleccionada.cuilTitular,
        domicilio: this.personaSeleccionada.nombreDomicilio,
        numeroDomicilio: this.personaSeleccionada.numeroDomicilio,
        piso: this.personaSeleccionada.piso,
        departamento: this.personaSeleccionada.departamento,
        estadoCivil: this.personaSeleccionada.estadoCivil?.descripcion,
        parentesco: this.personaSeleccionada.parentesco?.descripcion,
        plan: this.personaSeleccionada.plan?.descripcion,
        planFijo: this.personaSeleccionada.planFijo || false,
        sexo: this.personaSeleccionada.sexo?.descripcion,
        tipoBeneficiario:
          this.personaSeleccionada.tipoBeneficiario?.descripcion,
        obraSocial: this.personaSeleccionada.obraSocial?.descripcion,
        nacionalidad: this.personaSeleccionada.nacionalidad?.descripcion,
        revista: this.personaSeleccionada.revista?.descripcion,
        idEstadoCivil: this.personaSeleccionada.estadoCivil?.id,
        idParentesco: this.personaSeleccionada.parentesco?.id,
        idPlan: this.personaSeleccionada.plan?.id,
        idSexo: this.personaSeleccionada.sexo?.id,
        idTipoBeneficiario: this.personaSeleccionada.tipoBeneficiario?.id,
        idObraSocial: this.personaSeleccionada.obraSocial?.id,
        idNacionalidad: this.personaSeleccionada.nacionalidad?.id,
        idRevista: this.personaSeleccionada.revista?.id,
        numeroAfiliado: this.personaSeleccionada.numeroAfiliado,
        activo: this.personaSeleccionada.activo,
        idLocalidad: this.personaSeleccionada.localidad?.id,
        idVendedor: this.personaSeleccionada.vendedor?.id || null,
        aporteInicial: this.personaSeleccionada.aporteInicial || 0.0,
        cuitEmpresa:
          this.personaSeleccionada.cuitEmpresa ||
          (this.empresaSeleccionada ? this.empresaSeleccionada.cuit : null),
      };

      this.apiSrv.actualizarPersona(personaDTO).subscribe(
        (response) => {
          if (response.status === 201) {
            this.editando = false;
            this.recargarPersonas();
            this.toastSrv.mostrarNotificacion(
              'Persona actualizada correctamente',
              'success'
            );
          } else {
            this.toastSrv.mostrarNotificacion(
              'Error al actualizar la persona',
              'error'
            );
          }
        },
        (error) => {
          this.toastSrv.mostrarNotificacion(
            'Error al actualizar la persona. ' + error?.error,
            'error'
          );
        }
      );
    });
  }

  filtrarEmpresas(): void {
    const filtro = (this.empresaFiltro || '').toLowerCase();

    if (filtro.length < 3) {
      this.empresaFiltrada = [];
      return;
    }

    this.empresaFiltrada = this.empresas
      .filter((e) => {
        const coincideRazonSocial = e.razonSocial
          .toLowerCase()
          .includes(filtro);
        const coincideCuit = (e.cuit + '').toLowerCase().includes(filtro);
        return coincideRazonSocial || coincideCuit;
      })
      .sort((a, b) => a.razonSocial.localeCompare(b.razonSocial));

    // Aseguramos que cuitEmpresa sea string si está seteada
    if (
      this.personaSeleccionada &&
      this.personaSeleccionada.cuitEmpresa != null
    ) {
      this.personaSeleccionada.cuitEmpresa =
        this.personaSeleccionada.cuitEmpresa.toString();
    }
  }

  onEmpresaSeleccionada(cuit: any): void {
    // Asegurarnos que cuit siempre sea string para la comparación
    const cuitStr = cuit.toString();

    this.empresaSeleccionada = this.empresas.find(
      (e) => e.cuit.toString() === cuitStr
    );

    if (this.personaSeleccionada) {
      this.personaSeleccionada.cuitEmpresa = cuitStr;
    }
  }

  private validarPersonaPrimerCampo(): Promise<boolean> {
    return new Promise((resolve) => {
      this.errores = {};
      let valido = true;

      valido =
        this.validarCampo(
          this.personaSeleccionada.nombre,
          'nombre',
          this.SOLO_LETRAS,
          'El nombre es obligatorio.',
          'El nombre debe contener solo letras.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.apellido,
          'apellido',
          this.SOLO_LETRAS,
          'El apellido es obligatorio.',
          'El apellido debe contener solo letras.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.documento,
          'documento',
          this.DNI_VALIDO,
          'El documento es obligatorio.',
          'El documento debe contener solo números y tener exactamente 8 dígitos.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.fechaNacimiento,
          'fechaNacimiento',
          null,
          'La fecha de nacimiento es obligatoria.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.telefono,
          'telefono',
          this.TELEFONO_VALIDO,
          'El teléfono es obligatorio.',
          'El teléfono debe contener solo números y tener como mínimo 8 dígitos.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.cuil,
          'cuil',
          this.CUIL_VALIDO,
          'El cuil es obligatorio.',
          'El CUIL debe tener exactamente 11 dígitos numéricos.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.cuilTitular,
          'cuilTitular',
          this.CUIL_VALIDO,
          'El cuil del titular es obligatorio.',
          'El CUIL del titular debe tener exactamente 11 dígitos numéricos.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.nombreDomicilio,
          'domicilio',
          null,
          'El domicilio es obligatorio.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.numeroDomicilio,
          'numeroDomicilio',
          null,
          'El numero de domicilio es obligatorio.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.localidad?.id,
          'idLocalidad',
          null,
          'La localidad es obligatoria.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.sexo?.id,
          'idSexo',
          null,
          'El sexo es obligatorio.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.estadoCivil?.id,
          'idEstadoCivil',
          null,
          'El estado civil es obligatorio.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.nacionalidad?.id,
          'idNacionalidad',
          null,
          'La nacionalidad es obligatoria.'
        ) && valido;
      valido =
        this.validarCampo(
          this.personaSeleccionada.parentesco?.id,
          'idParentesco',
          null,
          'El parentesco es obligatorio.'
        ) && valido;

      const esTitular = this.personaSeleccionada.parentesco?.descripcion
        ?.toLowerCase()
        .includes('titular');

      if (valido) {
        Promise.all([this.verificarCuilTitular()])
          .then((results) => {
            resolve(results.every((result) => result));
          })
          .catch(() => {
            resolve(false);
          });
      } else {
        resolve(valido);
      }
    });
  }

  private verificarCuilTitular(): Promise<boolean> {
    return new Promise((resolve) => {
      if (
        this.personaSeleccionada.cuil !== this.personaSeleccionada.cuilTitular
      ) {
        this.apiSrv
          .obtenerPersona(this.personaSeleccionada.cuilTitular)
          .subscribe({
            next: (persona: any) => {
              if (!persona || !persona.cuil) {
                this.errores['cuilTitular'] =
                  'El titular con el CUIL proporcionado no existe.';
                this.personaSeleccionada.plan.id = '';
                this.personaSeleccionada.obraSocial.id = '';
                this.personaSeleccionada.revista.id = '';
                this.personaSeleccionada.tipoBeneficiario.id = '';
                this.personaSeleccionada.vendedor.id = '';
                (this.personaSeleccionada.empresaPrincipal.cuit = ''),
                  (this.personaSeleccionada.aporteInicial = 0.0);
                resolve(false);
              } else {
                this.personaSeleccionada.plan.id = persona?.plan?.id;
                this.personaSeleccionada.obraSocial.id =
                  persona?.obraSocial?.id;
                this.personaSeleccionada.revista.id = persona?.revista?.id;
                this.personaSeleccionada.tipoBeneficiario.id =
                  persona?.tipoBeneficiario?.id;

                if (!this.personaSeleccionada.vendedor) {
                  this.personaSeleccionada.vendedor = {};
                }

                this.personaSeleccionada.vendedor.id =
                  persona?.vendedor?.id || null;
                if (!this.personaSeleccionada.empresaPrincipal) {
                  this.personaSeleccionada.empresaPrincipal = {};
                }
                this.personaSeleccionada.empresaPrincipal.cuit =
                  persona?.empresaPrincipal?.cuit || null;
                this.personaSeleccionada.aporteInicial =
                  persona?.aporteInicial || 0.0;
                this.personaSeleccionada.planFijo = persona?.planFijo || false;

                resolve(true);
              }
            },
            error: () => {
              this.errores['cuilTitular'] =
                'Error al verificar el CUIL del titular.';
              resolve(false);
            },
          });
      } else {
        resolve(true);
      }
    });
  }

  private validarCampo(
    valor: any,
    campo: string,
    regex: RegExp | null,
    mensajeVacio: string,
    mensajeInvalido?: string
  ): boolean {
    if (valor === null || valor === undefined) {
      this.errores[campo] = mensajeVacio;
      return false;
    }
    if (regex && !regex.test(valor)) {
      this.errores[campo] = mensajeInvalido || 'Formato inválido.';
      return false;
    }
    return true;
  }

  cancelarEdicion(): void {
    this.editando = false;
  }

  limpiarCampos(): void {
    this.personaSeleccionada = {
      sexo: {},
      parentesco: {},
      estadoCivil: {},
      nacionalidad: {},
      obraSocial: {},
      plan: {},
      tipoBeneficiario: {},
      revista: {},
      localidad: { provincia: {} },
      fechaNacimiento: '',
      fechaVenta: '',
      vendedor: {},
      empresa: {},
      cuitEmpresa: null,
      aporteInicial: 0.0,
      planFijo: false,
    };

    this.empresaSeleccionada = null;
    this.empresaFiltro = '';
    this.empresaFiltrada = [];

    this.filtro['persona'] = '';
    this.mostrarBotonEditar = false;
    this.mostrarTabla = false;
    this.tieneAdherentes = false;
    this.errores = {};
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (
      event.key === 'Enter' &&
      this.termBusqueda &&
      this.termBusqueda.length >= 3
    ) {
      this.buscarPersonas();
    }
  }

  onFechaInput(event: Event, datepicker: any): void {
    const input = event.target as HTMLInputElement;

    // Guardar la posición del cursor
    const cursorPos = input.selectionStart || 0;

    let valor = (input.value || '').replace(/[^\d/]/g, '');

    // Detectar si el usuario está escribiendo barras manuales en posiciones NO estándar
    // Barras en posiciones 2 y 5 son auto-insertadas, otras son manuales
    const barrasEnPosiciones = [];
    for (let i = 0; i < valor.length; i++) {
      if (valor[i] === '/') {
        barrasEnPosiciones.push(i);
      }
    }

    // Verificar si hay barras en posiciones que NO son 2 o 5
    const tieneBarrasUsuario = barrasEnPosiciones.some(
      (pos) => pos !== 2 && pos !== 5
    );

    if (!tieneBarrasUsuario) {
      // Si no hay barras manuales, aplicar auto-formato
      const digitos = valor.replace(/\//g, '');

      let formatted = '';
      for (let i = 0; i < digitos.length && i < 8; i++) {
        // Insertar barra antes del tercer dígito (índice 2)
        if (i === 2) {
          formatted += '/';
        }
        // Insertar barra antes del quinto dígito (índice 4)
        if (i === 4) {
          formatted += '/';
        }
        formatted += digitos[i];
      }

      input.value = formatted;

      // Ajustar cursor
      let newCursorPos = cursorPos;
      if (formatted.length > cursorPos) {
        const barrasAntes = (
          formatted.substring(0, cursorPos).match(/\//g) || []
        ).length;
        newCursorPos = cursorPos + barrasAntes;
      }
      input.setSelectionRange(newCursorPos, newCursorPos);
    } else {
      // Si hay barras manuales, solo limpiar y permitir
      input.value = valor;
      input.setSelectionRange(cursorPos, cursorPos);
    }

    // Validar y sincronizar con el datepicker si el formato es completo
    const valorFinal = input.value;
    const partesFecha = valorFinal.split('/');

    if (
      partesFecha.length === 3 &&
      partesFecha[2].length === 4 &&
      partesFecha[0] &&
      partesFecha[1]
    ) {
      // Completar la fecha con ceros si es necesario (1/1/2000 -> 01/01/2000)
      const dia = partesFecha[0].padStart(2, '0');
      const mes = partesFecha[1].padStart(2, '0');
      const año = partesFecha[2];

      const fechaFormateada = `${dia}/${mes}/${año}`;
      input.value = fechaFormateada;

      const diaNum = parseInt(dia, 10);
      const mesNum = parseInt(mes, 10);
      const añoNum = parseInt(año, 10);

      // Validar que los valores sean válidos
      if (
        diaNum >= 1 &&
        diaNum <= 31 &&
        mesNum >= 1 &&
        mesNum <= 12 &&
        añoNum >= 1900 &&
        añoNum <= this.maxDate.year
      ) {
        // Crear la fecha para validar que sea válida y no sea futura
        const fechaValida = this.validarFecha(diaNum, mesNum, añoNum);
        const fechaIngresada = new Date(añoNum, mesNum - 1, diaNum);
        const fechaActual = new Date();
        const esFechaFutura = fechaIngresada > fechaActual;

        if (fechaValida && !esFechaFutura) {
          // Sincronizar con el datepicker
          try {
            datepicker.navigateTo({ year: añoNum, month: mesNum, day: diaNum });
            // Limpiar error de validación si la fecha es correcta
            if (this.errores['fechaNacimiento']) {
              delete this.errores['fechaNacimiento'];
            }
          } catch (error) {
            // Si hay error al navegar, no hacer nada
          }
        } else if (esFechaFutura) {
          // Mostrar error si la fecha es futura
          this.errores['fechaNacimiento'] =
            'La fecha de nacimiento no puede ser futura';
          this.toastSrv.mostrarNotificacion(
            'La fecha de nacimiento no puede ser futura',
            'error'
          );
        } else if (!fechaValida) {
          // Mostrar error si la fecha no es válida
          this.errores['fechaNacimiento'] = 'La fecha ingresada no es válida';
        }
      } else {
        // Si los valores están fuera de rango
        this.errores['fechaNacimiento'] = 'La fecha ingresada no es válida';
      }
    }
  }

  private validarFecha(dia: number, mes: number, año: number): boolean {
    // Validar que la fecha sea válida (considerando días del mes)
    const fecha = new Date(año, mes - 1, dia);
    return (
      fecha.getFullYear() === año &&
      fecha.getMonth() === mes - 1 &&
      fecha.getDate() === dia
    );
  }

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input) {
      this.personaSeleccionada.activo = input.checked ? 1 : 0;
    }
  }

  onProvinciaChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const provinciaId = parseInt(selectElement.value, 10);
    this.apiSrv.obtenerLocalidadesSegunIdProvincia(provinciaId).subscribe({
      next: (localidades) => {
        this.localidades = localidades;
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al cargar localidades.',
          'error'
        );
      },
    });
  }

  agregarAdherente(): void {
    this.personaModal.agregarAdherenteModal(
      this.personaSeleccionada,
      this.tipoModal
    );
  }

  eliminarModalBackdrop(): void {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }

  limpiarModalAgregarPersona(tipo: 'persona' | 'venta'): void {
    this.tipoModal = tipo;
    this.personaModal.limpiarModalAgregarPersona(tipo);
  }

  verTitular(): void {
    if (!this.personaSeleccionada.cuilTitular) {
      this.toastSrv.mostrarNotificacion(
        'No se encontró el CUIL del titular',
        'error'
      );
      return;
    }

    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerPersona(this.personaSeleccionada.cuilTitular).subscribe({
      next: (titular: any) => {
        this.loadingSrv.setLoading(false);
        if (titular && titular.cuil) {
          this.onSelectItem(titular);
        } else {
          this.toastSrv.mostrarNotificacion('Titular no encontrado', 'error');
        }
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          'Error al obtener el titular',
          'error'
        );
      },
    });
  }

  verAdherente(cuil: string): void {
    if (!cuil) {
      this.toastSrv.mostrarNotificacion(
        'CUIL de adherente no especificado',
        'error'
      );
      return;
    }

    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerPersona(cuil).subscribe({
      next: (adherente: any) => {
        this.loadingSrv.setLoading(false);
        if (adherente && adherente.cuil) {
          this.onSelectItem(adherente);
          this.activarPestañaDatosPersonales();
        } else {
          this.toastSrv.mostrarNotificacion('Adherente no encontrado', 'error');
        }
      },
      error: (error) => {
        this.loadingSrv.setLoading(false);
        this.toastSrv.mostrarNotificacion(
          'Error al obtener el adherente',
          'error'
        );
      },
    });
  }

  private parseDomicilio(domicilio: string): {
    calle: string;
    nro: string;
    piso: string;
    departamento: string;
  } {
    const partes = domicilio.split(',').map((p) => p.trim());
    let calle = '',
      nro = '',
      piso = '',
      departamento = '';

    partes.forEach((parte) => {
      if (parte.startsWith('Calle:')) {
        calle = parte.replace('Calle:', '').trim();
      } else if (parte.startsWith('Nro:')) {
        nro = parte.replace('Nro:', '').trim();
      } else if (parte.startsWith('Piso:')) {
        piso = parte.replace('Piso:', '').trim();
      } else if (parte.startsWith('Departamento:')) {
        departamento = parte.replace('Departamento:', '').trim();
      }
    });

    return { calle, nro, piso, departamento };
  }

  actualizarIdVendedor(idVendedor: any): void {
    if (!this.personaSeleccionada.vendedor) {
      this.personaSeleccionada.vendedor = { id: idVendedor };
    } else {
      this.personaSeleccionada.vendedor.id = idVendedor;
    }
  }

  abrirModalVendedor(): void {
    setTimeout(() => {
      if (this.vendedorModal) {
        this.vendedorModal.abrirModoCreacionVendedor();
      }
    }, 300);
  }

  actualizarListaVendedores(): void {
    if (
      this.editando &&
      this.personaSeleccionada?.parentesco.descripcion
        ?.toLowerCase()
        .includes('titular')
    ) {
      this.apiSrv.obtenerVendedoresActivos().subscribe({
        next: (data: any[]) => {
          this.vendedores = data;
        },
        error: (error) => {
          this.toastSrv.mostrarNotificacion(
            'Error al cargar la lista de vendedores',
            'error'
          );
        },
      });
    }
  }

  abrirModalEmpresa(): void {
    setTimeout(() => {
      if (this.empresaModal) {
        this.empresaModal.abrirModoCreacionEmpresa();

        // Asegurarse de actualizar la lista de empresas cuando se guarda una nueva
        if (!this.empresaModalSuscrito) {
          this.empresaModalSuscrito = true;

          this.empresaModal.empresaGuardada
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
              // Recargar la lista de empresas
              this.apiSrv.obtenerEmpresas().subscribe((data: any[]) => {
                this.empresas = (data || []).sort((a, b) =>
                  a.razonSocial.localeCompare(b.razonSocial)
                );
                this.empresaFiltrada = [];
                this.empresaFiltro = '';
              });
            });
        }
      }
    }, 300);
  }
  setDateLimits(): { minDate: NgbDateStruct; maxDate: NgbDateStruct } {
    const today = new Date();
    const maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
    };
    const minDate = {
      year: today.getFullYear() - 100,
      month: 1,
      day: 1,
    };

    // Actualiza las propiedades del componente
    this.maxDate = maxDate;
    this.minDate = minDate;

    // Retorna los valores para que puedan ser usados por otros componentes
    return { minDate, maxDate };
  }
}
